import styled from 'styled-components';
import { TimbaStanding } from '../api/client';

// Tabla de posiciones reutilizable. Muestra el top `top` (medallas a los 3 primeros) y, si el
// jugador no entra en ese top, agrega su fila abajo con su puesto real. Resalta su fila (filete).
export function TimbaBoard({
  standings,
  pub,
  top = 10,
  onDelete,
}: {
  standings: TimbaStanding[];
  pub: string;
  top?: number;
  onDelete?: (pub: string, nick: string) => void; // admin: borrar jugador (identidad fantasma)
}) {
  if (standings.length === 0) {
    return <Empty>Todavía no hay pronósticos. ¡Sé el primero!</Empty>;
  }
  const row = (r: TimbaStanding, i: number) => (
    <li key={r.pub} className={r.pub === pub ? 'me' : ''}>
      <span className="pos">{i < 3 ? ['🥇', '🥈', '🥉'][i] : i + 1}</span>
      <span className="who">{r.nick}{r.pub === pub ? ' (vos)' : ''}</span>
      <span className="meta">{r.exacts} exactos · {r.played} jug.</span>
      <span className="pts">{r.points}</span>
      {onDelete && (
        <button type="button" className="del" title="Borrar jugador" onClick={() => onDelete(r.pub, r.nick)}>🗑</button>
      )}
    </li>
  );
  const head = standings.slice(0, top);
  const myIdx = standings.findIndex((r) => r.pub === pub);
  return (
    <>
      <Ol className="scroll">{head.map((r, i) => row(r, i))}</Ol>
      {myIdx >= top && <Ol className="meRow">{row(standings[myIdx], myIdx)}</Ol>}
    </>
  );
}

const Empty = styled.p`
  padding: 16px 14px;
  margin: 0;
  font-size: 0.88rem;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Ol = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  &.scroll { max-height: 396px; overflow-y: auto; }
  &.meRow { margin-top: 12px; }
  &.meRow::before {
    content: 'Tu posición';
    display: block;
    font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.textMuted};
    margin: 0 0 6px 4px;
  }
  li { display: flex; align-items: center; gap: 10px; padding: 11px 14px; border-top: 1px solid ${({ theme }) => theme.colors.border}; }
  li:first-child { border-top: none; }

  /* Mi fila = card bien destacada (en el top o, si estoy más lejos, debajo del 10). */
  li.me {
    background: ${({ theme }) => theme.colors.accent};
    border: none;
    border-radius: 12px;
    margin: 6px;
    padding: 13px 14px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
  }
  li.me .pos, li.me .who, li.me .meta, li.me .pts { color: ${({ theme }) => theme.colors.accentText}; }
  li.me .meta { opacity: 0.85; }
  li.me .pts { font-size: 1.4rem; }

  .pos { width: 26px; font-size: 1.05rem; font-weight: 800; text-align: center; color: ${({ theme }) => theme.colors.textMuted}; }
  .who { flex: 1; font-weight: 700; }
  .meta { font-size: 0.74rem; color: ${({ theme }) => theme.colors.textMuted}; }
  .pts { font-weight: 900; font-size: 1.15rem; color: ${({ theme }) => theme.colors.accent}; min-width: 32px; text-align: right; }
  .del { flex: 0 0 auto; background: none; border: none; font-size: 1rem; opacity: 0.6; cursor: pointer; padding: 0 2px; }
  .del:hover { opacity: 1; }
`;
